export class Service {
    constructor(id = 0, code = '', name = '', description = '') {
        this.id = id;
        this.code = code
        this.name = name
        this.description = description
    }
}